import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Button from 'components/ui-elements/button'
import { graphql, useStaticQuery } from 'gatsby'
import useWindowSize from 'styles/window-size'
import { LocaleContext } from 'styles/locale-provider'

import {
  Wrap,
  Container,
  Item,
  Content,
  Logo,
  ImgWrap,
  Soon
} from './index.styled'

const BookSection = () => {
  const text = [
    'https://aubergeresorts.com/etereo',
    'https://www.marriott.com/en-us/hotels/cunxr-the-st-regis-kanai-resort-riviera-maya/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0',
    'https://www.marriott.com/en-us/hotels/cunek-the-riviera-maya-edition-at-kanai/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0',
    'https://press.mandarinoriental.com/mo-kanai-riviera-maya'
  ]
  const { isMobile } = useWindowSize()
  const { localeText } = React.useContext(LocaleContext)

  const { images, imagesMob } = useStaticQuery(graphql`
    query BookQuery {
      images: allFile(
        filter: {
          relativePath: {
            in: [
              "book-now/slide-1.png"
              "book-now/slide-2.png"
              "book-now/slide-3.png"
              "book-now/slide-4.png"
            ]
          }
        }, sort: {name: ASC}
      ) {
        nodes {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      imagesMob: allFile(
        filter: {
          relativePath: {
            in: [
              "book-now/slide-1_mobile.png"
              "book-now/slide-2_mobile.png"
              "book-now/slide-3_mobile.png"
              "book-now/slide-4_mobile.png"
            ]
          }
        }, sort: {name: ASC}
      ) {
        nodes {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  `)
  // console.dir(nodes)
  const items = isMobile ? imagesMob.nodes : images.nodes
  return (
    <Wrap>
      <Container>
        {items.map((image, i) => (
          <Item
            key={`book-logo-section-${i}`}
            href={text[i] || ''}
            as={text[i] ? 'a' : 'div'}
            target='_blank'
          >
            <ImgWrap>
              <GatsbyImage image={getImage(image)} alt='' />
            </ImgWrap>
            <Content>
              <Logo className={'logo-' + i} />
              {text[i]
                ? (
                  <Button className={isMobile && 'light-fill'}>
                    {i === 3 ? localeText['coming.soon'] : localeText['book.button']}
                  </Button>
                  )
                : (
                  <Soon>{localeText['coming.soon']}</Soon>
                  )}
            </Content>
          </Item>
        ))}
      </Container>
    </Wrap>
  )
}
export default BookSection
